export default __webpack_public_path__ + "static/media/story.e6bf841e.png";